import React, { useMemo } from 'react'

import { BalanceCell } from '../../../../../elements/BalanceCell'
import { PeriodValue } from '../../../../../types/inputTypes'
import { useBalanceSheetFilters } from '../../contexts/balanceSheetFiltersContext'
import { BalanceSheetTableRow } from '../../types/tableTypes'

interface BalanceSheetCellsProps {
  row: BalanceSheetTableRow
  periods: PeriodValue[]
}

export const BalanceSheetCells = ({ row, periods }: BalanceSheetCellsProps) => {
  const { appliedFilters } = useBalanceSheetFilters()
  const periodQuery = useMemo(() => appliedFilters.period, [appliedFilters.period])

  return (
    <>
      {periods.map((period) => {
        const balance = row.balances.find((balance) => balance.period === period.key)?.balance || 0

        return (
          <BalanceCell
            key={period.key}
            type={row.type}
            balance={balance}
            id={row.originalId || row.id}
            periodQuery={periodQuery}
          />
        )
      })}
    </>
  )
}
